import MathHelpers from "./MathHelpers";

export default class PositionMath {
  static calculateFloatTextXY(
    x,
    y,
    min = -40,
    max = 40
  ): { newX: number; newY: number } {
    let forX = MathHelpers.RandomInteger(min, max);
    let forY = MathHelpers.RandomInteger(min, max);

    return { newX: x + forX, newY: y + forY };
  }
}
